import axios from '../axios';
import type {
  ApiEnvelope,
  Identifier,
  OwnerMonitoringDto,
  OwnerReportDto,
  OwnerApprovalDto,
} from './types';

const projectUrl = (projectId: Identifier) =>
  `/v1/owner/manpro/projects/${projectId}`;

const ownerMonitoringService = {
  
  async getOwnerMonitoring(projectId: Identifier) {
    const response = await axios.get<ApiEnvelope<OwnerMonitoringDto>>(
      `${projectUrl(projectId)}/monitoring`,
    );

    return response.data.content;
  },

  async getOwnerReports(projectId: Identifier) {
    const response = await axios.get<ApiEnvelope<{ reports: OwnerReportDto[] }>>(
      `${projectUrl(projectId)}/reports`,
    );

    return response.data.content;
  },

  async uploadOwnerPhoto(projectId: Identifier, data: FormData) {
    const response = await axios.post<ApiEnvelope<any>>(
      `${projectUrl(projectId)}/reports`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return response.data;
  },

  async getOwnerDocuments(projectId: Identifier) {
    const response = await axios.get<ApiEnvelope<unknown[]>>(
      `${projectUrl(projectId)}/documents`,
    );

    return response.data.content;
  },

  async getOwnerApprovals(projectId: Identifier) {
    const response = await axios.get<ApiEnvelope<{ approvals: OwnerApprovalDto[] }>>(
      `${projectUrl(projectId)}/approvals`,
    );

    return response.data.content;
  },

  async approveOwnerApproval(projectId: Identifier, approvalId: Identifier) {
    const response = await axios.post<ApiEnvelope<unknown>>(
      `${projectUrl(projectId)}/approvals/${approvalId}/approve`,
    );

    return response.data.content;
  },

  async rejectOwnerApproval(projectId: Identifier, approvalId: Identifier, reason: string) {
    const response = await axios.post<ApiEnvelope<unknown>>(
      `${projectUrl(projectId)}/approvals/${approvalId}/reject`,
      { rejection_reason: reason }
    );

    return response.data.content;
  },
};

export default ownerMonitoringService;
